import { Link as RouterLink } from "react-router";
import { cn } from "@/utils/css";

export const Link = ({ url, target, className, theme = "button", children }) => {
    return (
        <RouterLink
            to={url}
            target={target}
            className={cn("text-cm-p-on-container-green hover:text-cm-p-on-container-green text-base", className, {
                "bg-cm-p-accent w-full h-full rounded py-[15px] px-10 font-bold": theme === "button",
            })}
        >
            {children}
        </RouterLink>
    );
};
